export const Contact = () => {
    return (
        <div className="mt-10">
            <h1 className="text-xl text-center font-semibold text-gray-500">
                Hey this is Rajeev Krishna.
            </h1>
        </div>
    )
}